import { Col, Container, Row } from "react-bootstrap";
import FilterSelect from "../components/FilterSelect";
import SearchBar from "../components/SeachBar/SearchBar";
import { Fragment, useState } from "react";
import { products } from "../utils/products";
import ShopList from "../components/ShopList";
import Banner from "../components/Banner/Banner";
import useWindowScrollToTop from "../hooks/useWindowScrollToTop";
import WholesaleEnquiry from "../components/More/WholeSaleEnquiry";


const EnquiryPage = () => {
  // const [filterList, setFilterList] = useState(
  //   products.filter((item) => item.category === "sofa")
  // );
  useWindowScrollToTop();

  return (
    <Fragment>
      <Banner title="Enquiry" />
      {/* <section className="filter-bar"> */}
        <Container className="filter-bar-contianer">
          {/* <Row className="justify-content-center"> */}
            {/* <Col md={4}>
              <FilterSelect setFilterList={setFilterList} />
            </Col> */}
            {/* <Col md={8}>
              <SearchBar setFilterList={setFilterList} />
            </Col> */}
          {/* </Row> */}
        </Container>
        <Container>
          <WholesaleEnquiry />
          {/* <ShopList productItems={filterList} /> */}
        </Container>
      {/* </section> */}
    </Fragment>
  );
};

export default EnquiryPage;
